import React from 'react'
import { useMsal, useIsAuthenticated } from '@azure/msal-react'
import { loginRequest } from './msalConfig'

interface AuthGuardProps {
  children: React.ReactNode
}

/**
 * Renders children only when the user is authenticated via Azure Entra ID.
 * Automatically redirects to MSAL login popup if not signed in.
 */
export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { instance, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  if (inProgress === 'login' || inProgress === 'handleRedirect') {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', backgroundColor: 'var(--bg-primary)',
        color: 'var(--text-secondary)', fontFamily: 'var(--font-sans)',
        gap: '12px', fontSize: '0.9rem',
      }}>
        <span style={{ width: 20, height: 20, borderRadius: '50%', border: '2px solid var(--accent)', borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite', display: 'inline-block' }} />
        Authenticating…
      </div>
    )
  }

  if (!isAuthenticated) {
    instance.loginRedirect(loginRequest).catch(console.error)
    return null
  }

  return <>{children}</>
}
